import { useLocation } from 'react-router-dom';

import { isSelfServeCampaignPromoActive } from '../utils/elevatedCampaignActive';

/**
 * Re-evaluates when route or ?promoSeries= changes (build-time promo is static).
 * Same gate as checkout discount UI.
 */
export function useSelfServeCampaignPromoActive() {
  useLocation();
  return isSelfServeCampaignPromoActive();
}

/** @deprecated Prefer useSelfServeCampaignPromoActive */
export function useElevatedCampaignActive() {
  return useSelfServeCampaignPromoActive();
}
